import { render, staticRenderFns } from "./addServices.vue?vue&type=template&id=4b1e68d7&scoped=true&"
import script from "./addServices.vue?vue&type=script&lang=js&"
export * from "./addServices.vue?vue&type=script&lang=js&"
import style0 from "./addServices.vue?vue&type=style&index=0&id=4b1e68d7&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b1e68d7",
  null
  
)

export default component.exports